(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    function initMoreDropdown(overflowMenu) {
    const moreItem = overflowMenu.querySelector('[slot="more"]');
    const moreBtn = moreItem?.querySelector('button');
    if (!moreBtn) return;

    function getHeaderComponent() {
      return overflowMenu.closest('#header-component');
    }

    function getOverflowPanel() {
      return overflowMenu.shadowRoot?.querySelector('[part="overflow"]');
    }

    function open() {
      moreBtn.setAttribute('aria-expanded', 'true');
      const headerMenu = overflowMenu.closest('header-menu');
      if (headerMenu) headerMenu.dataset.overflowExpanded = 'true';
      const panel = getOverflowPanel();
      const hc = getHeaderComponent();
      if (panel && hc) {
        hc.style.setProperty('--submenu-height', `${panel.offsetHeight}px`);
      }
    }

    function close() {
      var overflowLink = overflowMenu.querySelector('[slot="overflow"] [ref="menuitem"]');
      if (overflowLink) overflowLink.setAttribute('aria-expanded', 'false');
      moreBtn.setAttribute('aria-expanded', 'false');
      const headerMenu = overflowMenu.closest('header-menu');
      if (headerMenu) headerMenu.dataset.overflowExpanded = 'false';
      const hc = getHeaderComponent();
      if (hc) hc.style.setProperty('--submenu-height', '0px');
    }

    function isOpen() {
      return moreBtn.getAttribute('aria-expanded') === 'true';
    }

    function isTablet() {
      return window.innerWidth >= 750 && window.innerWidth <= 989;
    }

    moreBtn.addEventListener('click', (e) => {
      if (!isTablet()) return;
      e.stopPropagation();
      isOpen() ? close() : open();
    });

    document.addEventListener('click', (e) => {
      if (!isTablet()) return;
      if (isOpen() && !overflowMenu.contains(e.target)) {
        close();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (!isTablet()) return;
      if (e.key === 'Escape' && isOpen()) close();
    });
  }

  document.querySelectorAll('.overflow-menu').forEach(initMoreDropdown);

  (function () {
    function isTablet() {
      return window.innerWidth >= 750 && window.innerWidth <= 989;
    }

    function closeAllTablet() {
      document.querySelectorAll('.header-menu .menu-list__list-item[data-tablet-open]')
        .forEach(function (el) { el.removeAttribute('data-tablet-open'); });
    }

    document.querySelectorAll('.header-menu .menu-list__list-item:not([slot])').forEach(function (item) {
      var link = item.querySelector('[ref="menuitem"][aria-haspopup]');
      if (!link) return;

      link.addEventListener('click', function (e) {
        if (!isTablet()) return;
        e.preventDefault();
        if (item.hasAttribute('data-tablet-open')) {
          item.removeAttribute('data-tablet-open');
        } else {
          closeAllTablet();
          item.setAttribute('data-tablet-open', '');
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!isTablet()) return;
      if (!e.target.closest('.header-menu .menu-list__list-item:not([slot])')) {
        closeAllTablet();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllTablet();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_vpl-cta"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__vplAtcListenerAdded) return;
    window.__vplAtcListenerAdded = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vpl-atc]');
      if (!btn || btn.disabled) return;

      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.dataset.variantId;
      var productId = btn.dataset.productId;
      var labelEl = btn.querySelector('.vpl-cta__label');
      var originalText = labelEl ? labelEl.textContent : '';

      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            btn.disabled = false;
            return;
          }

          if (labelEl) {
            labelEl.textContent =
              window.Theme && window.Theme.translations && window.Theme.translations.added
                ? window.Theme.translations.added
                : 'Added!';
          }

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: response,
                sourceId: variantId,
                data: { source: 'vpl-cta', itemCount: 1, productId: productId },
              },
            })
          );

          setTimeout(function () {
            btn.disabled = false;
            if (labelEl) labelEl.textContent = originalText;
          }, 1500);
        })
        .catch(function () {
          btn.disabled = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-more-save-more"] && !Shopify.designMode) return;
  try {
    (() => {
    function updateTotal(container, option) {
      const priceEl = option.querySelector('.bms-price');
      const compareEl = option.querySelector('.bms-compare-price');

      const totalPrice = container.querySelector('[data-bms-total-price]');
      if (totalPrice && priceEl) {
        totalPrice.textContent = priceEl.textContent;
      }

      const totalCompare = container.querySelector('[data-bms-total-compare]');
      if (totalCompare) {
        if (compareEl) {
          totalCompare.textContent = compareEl.textContent;
          totalCompare.hidden = false;
        } else {
          totalCompare.textContent = '';
          totalCompare.hidden = true;
        }
      }
    }

    function updateAddToCartLabel(container, option) {
      const label = container.querySelector('[data-testid="bms-add-to-cart"] .add-to-cart-text__content span span');
      if (!label) return;

      const baseLabel = container.dataset.addToCartBaseLabel || label.textContent;
      const percent = Number(option.dataset.percent) || 0;

      label.textContent = percent > 0 ? `${baseLabel} (${percent}% off)` : baseLabel;
    }

    function selectOption(container, option) {
      container.querySelectorAll('[data-bms-option]').forEach((el) => {
        el.classList.toggle('bms-option--selected', el === option);
      });

      const quantityInput = container.querySelector('[data-bms-quantity-input]');
      if (quantityInput) {
        quantityInput.value = option.dataset.qty;
      }

      container.dataset.bmsDiscountCode = option.dataset.discountCode || '';

      updateTotal(container, option);
      updateAddToCartLabel(container, option);
    }

    // Sets the cart's discount to the tier just selected (or clears it for a tier
    // with no code, e.g. Single). /cart/update.js's discount field REPLACES the
    // cart's entire discount list rather than adding to it, so a single direct call
    // both applies the new tier's code and drops whatever this widget applied for
    // a previously-selected tier — no need to read the cart first to figure out
    // what to keep. This is a dedicated single-purpose offer page, so any other
    // discount code a customer separately entered isn't expected to coexist here;
    // trading that off is what let this drop from three requests (read + write,
    // plus the add) to two, which meaningfully reduced how often UpCart's own
    // auto-open-on-cart-activity behavior fought with our loading state.
    async function syncDiscountCode(container, code) {
      if (typeof Theme === 'undefined' || !Theme.routes || !Theme.routes.cart_update_url) return;

      try {
        const response = await fetch(Theme.routes.cart_update_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code || '' }),
          cache: 'no-store',
        });

        const data = await response.json();
        document.dispatchEvent(
          new CustomEvent('discount:update', {
            bubbles: true,
            detail: { resource: data, sourceId: null, data: {} },
          })
        );

        // UpCart only redraws its drawer for cart mutations made through its own
        // internal calls — requests we make ourselves update the cart correctly on
        // the server but leave the drawer showing stale pricing unless we explicitly
        // tell UpCart to refresh via its own public API.
        if (typeof window.upcartRefreshCart === 'function') {
          window.upcartRefreshCart();
        }
      } catch (error) {
        console.error(error);
      }
    }

    // A self-contained loading cover, created once and appended directly to
    // <body> (not nested inside this widget) so it sits above literally
    // everything on the page via z-index, including any third-party cart
    // drawer. Deliberately does not read or modify anything belonging to
    // UpCart or any other script — earlier attempts to directly toggle
    // UpCart's own open/closed state and DOM caused new, different visual
    // glitches each time (button flicker, then drawer open/close flicker, then
    // a full-screen light/dark strobe), because they depended on guessing at
    // undocumented internals. Covering the whole screen ourselves sidesteps
    // that entirely: whatever any other script does underneath during the
    // add+discount sequence is simply never seen.
    function getLoadingOverlay() {
      let overlay = document.getElementById('bms-loading-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'bms-loading-overlay';
        overlay.className = 'bms-loading-overlay';
        overlay.setAttribute('aria-hidden', 'true');
        const spinner = document.createElement('span');
        spinner.className = 'bms-loading-overlay__spinner';
        overlay.appendChild(spinner);
        document.body.appendChild(overlay);
      }
      return overlay;
    }

    function showLoadingOverlay() {
      getLoadingOverlay().classList.add('bms-loading-overlay--visible');
    }

    function hideLoadingOverlay() {
      const overlay = document.getElementById('bms-loading-overlay');
      if (overlay) overlay.classList.remove('bms-loading-overlay--visible');
    }

    // Adds the selected tier to the cart directly (bypassing the theme's normal
    // submit flow), since third-party cart-drawer scripts (e.g. UpCart) take over
    // this button's click and would otherwise swallow it before our own discount
    // sync ever ran. Then syncs the discount code so the cart drawer reflects it.
    // The customer stays on the page and opens checkout themselves from there.
    //
    // The add + discount sync is a couple of sequential requests, so it isn't
    // instant. The button shows a spinner and the tier cards are disabled for
    // feedback, and the full-screen loading cover stays up for the whole
    // sequence, so it's only ever removed once with the final, correct state
    // already in place.
    async function addToCartAndSyncDiscount(container, variantId, quantity, code) {
      if (!variantId || typeof Theme === 'undefined' || !Theme.routes || !Theme.routes.cart_add_url) return;

      const button = container.querySelector('[data-testid="bms-add-to-cart"]');

      container.dataset.bmsLoading = 'true';
      if (button) button.disabled = true;
      showLoadingOverlay();

      try {
        const response = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: Number(quantity) || 1 }),
          cache: 'no-store',
        });

        const data = await response.json();
        if (data.status) {
          console.error(data.message || 'Failed to add to cart', data.description);
          return;
        }

        await syncDiscountCode(container, code);
      } catch (error) {
        console.error(error);
      } finally {
        // Extra buffer after the requests resolve, so UpCart's own drawer
        // has time to fully settle on the correct state before it's revealed.
        await new Promise((resolve) => setTimeout(resolve, 2000));

        delete container.dataset.bmsLoading;
        if (button) button.disabled = false;
        hideLoadingOverlay();
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
      }
    }

    // Intercepts the Add to Cart click in the capture phase, before any
    // third-party script bound to this button (bubble phase, or attached later)
    // gets a chance to run, and before the button's default form-submit behavior
    // fires — so this widget always owns the entire add-to-cart flow.
    function handleAddToCartCapture(event) {
      const button = event.target.closest('[data-testid="bms-add-to-cart"]');
      if (!button || button.disabled) return;

      const container = button.closest('.buy-more-save-more');
      if (!container) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const variantInput = container.querySelector('[ref="variantId"]');
      const quantityInput = container.querySelector('[data-bms-quantity-input]');
      const variantId = variantInput ? variantInput.value : '';
      const quantity = quantityInput ? quantityInput.value : '1';
      const code = container.dataset.bmsDiscountCode || '';

      addToCartAndSyncDiscount(container, variantId, quantity, code);
    }

    function handleOptionClick(event) {
      const option = event.target.closest('[data-bms-option]');
      if (!option) return;

      event.preventDefault(); // selecting a card only selects it — nothing is added to cart yet

      const container = option.closest('.buy-more-save-more');
      if (!container) return;

      selectOption(container, option);
    }

    function initContainer(container) {
      if (container.dataset.bmsInitialized === 'true') return;
      container.dataset.bmsInitialized = 'true';

      // Pre-selecting a default tier keeps the Add to Cart button enabled at all
      // times (never starting `disabled`), since our own capture-phase click
      // handler now owns the entire add-to-cart flow regardless of button state.
      const defaultOption =
        container.querySelector('[data-bms-option].bms-option--featured') ||
        container.querySelector('[data-bms-option]');
      if (defaultOption) selectOption(container, defaultOption);
    }

    function initAll() {
      document.querySelectorAll('.buy-more-save-more').forEach(initContainer);
    }

    if (!window.__bmsClickBound) {
      window.__bmsClickBound = true;
      document.addEventListener('click', handleOptionClick);
      // Bound on window (the earliest possible point in the capture chain) so this
      // runs before any listener a third-party cart-drawer script (e.g. UpCart) may
      // have bound anywhere else, including its own capture-phase listeners.
      window.addEventListener('click', handleAddToCartCapture, true);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["selling-plans"] && !Shopify.designMode) return;
  try {
    (() => {
    const SELECTOR = '.selling-plans-block';

    function getProductForm(block) {
      const sectionId = block.dataset.sectionId;
      return document.getElementById(`BuyButtons-ProductForm-${sectionId}`);
    }

    function getPriceText(item, useCurrency) {
      return useCurrency ? item.price_formatted_with_currency : item.price_formatted;
    }

    function getCompareText(item, useCurrency) {
      return useCurrency ? item.compare_at_price_formatted_with_currency : item.compare_at_price_formatted;
    }

    function ensureSellingPlanInput(form) {
      let input = form.querySelector('input[name="selling_plan"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        form.appendChild(input);
      }
      return input;
    }

    function getCurrentVariantId(form) {
      return form.querySelector('input[name="id"]')?.value || '';
    }

    function getPlanLabel(allocation, index) {
      return allocation?.selling_plan_name || 'Subscription';
    }

    function renderOptions(block, variantData, selectedPlanId) {
      const optionsEl = block.querySelector('[data-selling-plan-options]');
      if (!optionsEl || !variantData) return;

      const useCurrency = block.dataset.useCurrency === 'true';
      const groupName = `selling_plan_option_${block.dataset.sectionId}_${block.dataset.productId}`;
      const rows = [];
      const allocations = variantData.allocations || [];
      const hasPlans = allocations.length > 0;
      const selectedAllocation =
        allocations.find((allocation) => String(allocation.selling_plan_id) === String(selectedPlanId)) || allocations[0];
      const isSubscribeSelected = hasPlans && !!selectedPlanId;

      if (hasPlans && selectedAllocation) {
        rows.push(`
          <div class="selling-plans-block__option selling-plans-block__option--subscribe" data-selected="${
            isSubscribeSelected ? 'true' : 'false'
          }">
            <label class="selling-plans-block__option-row">
              <span class="selling-plans-block__option-main">
                <input
                  type="radio"
                  name="${groupName}"
                  value="${selectedAllocation.selling_plan_id}"
                  data-plan-type="subscribe"
                  ${isSubscribeSelected ? 'checked' : ''}
                >
                <span class="selling-plans-block__option-title">Subscribe & Save ${selectedAllocation.percent_off}%</span>
              </span>
              <span class="selling-plans-block__price-inline">
                <span class="compare-at-price">${
                  useCurrency
                    ? selectedAllocation.compare_at_price_formatted_with_currency
                    : selectedAllocation.compare_at_price_formatted
                }</span>
                <span class="price">${
                  useCurrency ? selectedAllocation.price_formatted_with_currency : selectedAllocation.price_formatted
                }</span>
              </span>
            </label>
            <div class="selling-plans-block__dropdown-wrap">
              <select class="selling-plans-block__dropdown" data-selling-plan-select>
                ${allocations
                  .map((allocation, index) => {
                    const selected = String(selectedAllocation.selling_plan_id) === String(allocation.selling_plan_id);
                    return `<option value="${allocation.selling_plan_id}" ${selected ? 'selected' : ''}>${getPlanLabel(
                      allocation,
                      index
                    )}</option>`;
                  })
                  .join('')}
              </select>
            </div>
          </div>
        `);
      }

      rows.push(`
        <div class="selling-plans-block__option selling-plans-block__option--one-time" data-selected="${
          !selectedPlanId ? 'true' : 'false'
        }">
          <label class="selling-plans-block__option-row">
            <span class="selling-plans-block__option-main">
              <input type="radio" name="${groupName}" value="" data-plan-type="one-time" ${!selectedPlanId ? 'checked' : ''}>
              <span class="selling-plans-block__option-title">One-Time Purchase</span>
            </span>
            <span class="selling-plans-block__price-inline">
              <span class="price">${useCurrency ? variantData.base_price_formatted_with_currency : variantData.base_price_formatted}</span>
            </span>
          </label>
        </div>
      `);

      optionsEl.innerHTML = rows.join('');
    }

    function ensureCompareGroup(priceEl, regularPriceLabel) {
      let compare = priceEl.querySelector('.compare-at-price');
      if (compare) return compare;

      const compareGroup = document.createElement('span');
      compareGroup.setAttribute('role', 'group');
      const hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      hidden.textContent = `${regularPriceLabel} `;
      compare = document.createElement('span');
      compare.className = 'compare-at-price';
      compareGroup.append(hidden, compare);

      const priceSpan = priceEl.querySelector('.price');
      if (priceSpan && priceSpan.parentElement?.getAttribute('role') === 'group') {
        priceSpan.parentElement.insertAdjacentElement('afterend', compareGroup);
      } else if (priceSpan) {
        priceSpan.insertAdjacentElement('beforebegin', compareGroup);
      } else {
        priceEl.prepend(compareGroup);
      }

      return compare;
    }

    function updatePriceDisplay(block, form, map, selectedPlanId) {
      const variantId = getCurrentVariantId(form);
      if (!variantId || !map[variantId]) return;

      const variantData = map[variantId];
      const useCurrency = block.dataset.useCurrency === 'true';
      const regularPriceLabel = block.dataset.regularPriceLabel || 'Regular price';
      const priceBlocks = block
        .closest('.shopify-section, dialog, featured-product-information')
        ?.querySelectorAll(`product-price[data-product-id="${block.dataset.productId}"]`);

      if (!priceBlocks || priceBlocks.length === 0) return;

      let finalPriceCents = variantData.base_price_cents;
      let comparePriceCents = variantData.base_compare_at_price_cents;
      let finalPriceText = useCurrency ? variantData.base_price_formatted_with_currency : variantData.base_price_formatted;
      let comparePriceText = '';
      let isSellingPlanActive = false;

      if (selectedPlanId) {
        const allocation = (variantData.allocations || []).find(
          (item) => String(item.selling_plan_id) === String(selectedPlanId)
        );
        if (allocation) {
          isSellingPlanActive = true;
          finalPriceCents = allocation.price_cents;
          comparePriceCents = allocation.compare_at_price_cents;
          finalPriceText = getPriceText(allocation, useCurrency);
          comparePriceText = getCompareText(allocation, useCurrency);
        }
      }

      if (!comparePriceText && comparePriceCents > 0) {
        comparePriceText = useCurrency
          ? variantData.base_price_formatted_with_currency
          : variantData.base_price_formatted;
      }

      const showCompare = Number(comparePriceCents) > Number(finalPriceCents);

      priceBlocks.forEach((priceBlock) => {
        const priceContainer = priceBlock.querySelector('[ref="priceContainer"]') || priceBlock;
        const price = priceBlock.querySelector('.price');
        if (price) price.textContent = finalPriceText;

        const compare = ensureCompareGroup(priceBlock, regularPriceLabel);
        const priceGroup = price?.closest('[role="group"]');
        const compareGroup = compare.closest('[role="group"]');

        if (priceGroup && compareGroup) {
          priceContainer.append(priceGroup);
          priceContainer.append(compareGroup);
        }

        if (showCompare) {
          compare.textContent = comparePriceText;
          if (compareGroup) compareGroup.style.display = '';
        } else if (compareGroup) {
          compareGroup.style.display = 'none';
        }

        priceBlock.classList.toggle('selling-plan-price-active', isSellingPlanActive);
      });

      document.dispatchEvent(
        new CustomEvent('selling-plan:price-update', {
          detail: {
            productId: block.dataset.productId,
            variantId: String(variantId),
            selectedPlanId: selectedPlanId || '',
            finalPriceText,
            comparePriceText,
            showCompare,
            isSellingPlanActive,
            regularPriceLabel,
          },
        })
      );
    }

    function initBlock(block) {
      if (block.dataset.initialized === 'true') return;

      const form = getProductForm(block);
      if (!form) return;

      const jsonEl = block.querySelector('[data-selling-plan-price-map]');
      if (!jsonEl) return;

      let map = {};
      try {
        map = JSON.parse(jsonEl.textContent || '{}');
      } catch (error) {
        console.error('Failed to parse selling plan map', error);
        return;
      }

      const sellingPlanInput = ensureSellingPlanInput(form);
      const variantInput = form.querySelector('input[name="id"]');

      const sync = () => {
        const variantId = getCurrentVariantId(form);
        const variantData = map[variantId];
        if (!variantData) {
          block.style.display = 'none';
          return;
        }
        block.style.display = '';

        const validSelectedPlan =
          sellingPlanInput.value &&
          (variantData.allocations || []).some((item) => String(item.selling_plan_id) === String(sellingPlanInput.value));
        if (!validSelectedPlan) {
          const hasAllocations = variantData.allocations && variantData.allocations.length > 0;
          const userSelectedOneTime = block.dataset.userSelectedOneTime === 'true';

          if (hasAllocations && !userSelectedOneTime) {
            /* Default to first subscription plan unless user explicitly chose one-time purchase. */
            sellingPlanInput.value = String(variantData.allocations[0].selling_plan_id);
          } else {
            sellingPlanInput.value = '';
          }
        }

        renderOptions(block, variantData, sellingPlanInput.value);
        updatePriceDisplay(block, form, map, sellingPlanInput.value);

        block.querySelectorAll('input[type="radio"]').forEach((radio) => {
          radio.addEventListener('change', (event) => {
            const radioValue = event.currentTarget.value || '';
            const planType = event.currentTarget.dataset.planType || '';
            if (planType === 'subscribe') {
              block.dataset.userSelectedOneTime = 'false';
              const selectedPlan = block.querySelector('[data-selling-plan-select]')?.value || radioValue;
              sellingPlanInput.value = selectedPlan || radioValue;
            } else {
              block.dataset.userSelectedOneTime = 'true';
              sellingPlanInput.value = '';
            }
            sync();
          });
        });

        const select = block.querySelector('[data-selling-plan-select]');
        if (select) {
          select.addEventListener('change', (event) => {
            const planId = event.currentTarget.value || '';
            block.dataset.userSelectedOneTime = 'false';
            sellingPlanInput.value = planId;
            const subscribeRadio = block.querySelector('input[type="radio"][data-plan-type="subscribe"]');
            if (subscribeRadio) subscribeRadio.checked = true;
            sync();
          });
        }
      };

      if (variantInput) {
        variantInput.addEventListener('change', sync);
      }
      const sectionRoot = block.closest('.shopify-section, dialog, featured-product-information');
      sectionRoot?.addEventListener('variant:update', () => setTimeout(sync, 0));

      sync();
      block.dataset.userSelectedOneTime = 'false';
      block.dataset.initialized = 'true';
    }

    const initAll = () => document.querySelectorAll(SELECTOR).forEach(initBlock);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
